import './add_product_modal.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';


function Add_product_modal({open_add_product_modal,setOpen_add_product_modal,articles,setArticles}){


  const [errorText,setErrorText] = useState("");

  const [description,setdescription]=useState('');


  function submit_refuse_description() {
    setErrorText("");
    if(description===''){
        setErrorText("Champ vide !");
      }else{
        let tmp_array = [ ...articles ];
        tmp_array.push(description);
        setArticles(tmp_array);
        setdescription('');
        setOpen_add_product_modal(false);
      }     
   }

     

    return (
      <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_add_product_modal} onClose={()=>setOpen_add_product_modal(false)} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Décrivez l'article que vous souhaitez et sa quantité</DialogTitle>
        <DialogContent>
          <div>
                {
                    errorText === "" 
                    ?<></>
                    :<p className={errorText ? "error" : "valid-champ"}>
                            {errorText}
                        </p>
                }

              <div style={{width:"100%",marginTop:"5px"}} >
              <TextField
                  id="outlined-multiline-flexible"
                  label="Description"
                  variant='outlined'
                  multiline
                  minRows={4}
                  value={description}
                  onChange={(e)=>setdescription(e.target.value)} 
                  style={{width:"100%"}}
                />
              </div>
          </div>
          
     </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
              <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon className="my_icon" />} onClick={()=>setOpen_add_product_modal(false)} >
                  Annuler
              </Button>
              <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon className="my_icon"  />} onClick={submit_refuse_description} >
                  Ajouter
              </Button> 
            </div>
          </div>
        </DialogActions>
      </Dialog>
    )
}

export default Add_product_modal
